 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"@walletconnect/universal-provider":"@walletconnect/universal-provider","@walletconnect/web3-provider~tronweb~web3~web3-utils":"@walletconnect/web3-provider~tronweb~web3~web3-utils","@walletconnect/web3-provider~web3~web3-utils":"@walletconnect/web3-provider~web3~web3-utils","web3-utils":"web3-utils","tronweb~web3":"tronweb~web3","web3":"web3","tronweb":"tronweb","add-role-modal":"add-role-modal","cash-modals~job-modals":"cash-modals~job-modals","cash-modals":"cash-modals","ckeditor~public-page-vacancies~salary-pages":"ckeditor~public-page-vacancies~salary-pages","ckeditor":"ckeditor","salary-pages":"salary-pages","date-picker":"date-picker","erc20-lht-v1":"erc20-lht-v1","erc20-v1.json":"erc20-v1.json","image-cropper":"image-cropper","lx-analytics":"lx-analytics","lx-contract-v1":"lx-contract-v1","lx-contract-v2":"lx-contract-v2","private-pages~public-page-customers":"private-pages~public-page-customers","public-page-customers":"public-page-customers","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies","public-page-jobs~public-page-vacancies":"public-page-jobs~public-page-vacancies","jobs-modals~public-page-vacancies":"jobs-modals~public-page-vacancies","public-page-vacancies":"public-page-vacancies","private-pages~public-page-jobs":"private-pages~public-page-jobs","private-pages":"private-pages","public-page-freelancers~public-page-gigs":"public-page-freelancers~public-page-gigs","public-page-freelancers":"public-page-freelancers","public-page-gigs":"public-page-gigs","public-page-jobs":"public-page-jobs","public-page-about":"public-page-about","public-page-blog":"public-page-blog","public-page-landing":"public-page-landing","public-page-landing-copy":"public-page-landing-copy","public-page-mining":"public-page-mining","public-page-premium":"public-page-premium","public-page-skills":"public-page-skills","qr-code":"qr-code","recaptcha":"recaptcha","sentry":"sentry","settings-modals":"settings-modals","swiper":"swiper","time-warp-pool":"time-warp-pool","vue-slider-component":"vue-slider-component","welcome-modal":"welcome-modal","@walletconnect/web3-provider":"@walletconnect/web3-provider","skills-modals":"skills-modals","job-modals":"job-modals","jobs-modals":"jobs-modals","transak-sdk":"transak-sdk","gig-modals":"gig-modals","share-modal":"share-modal","application-modal":"application-modal","stack-grid":"stack-grid"}[chunkId]||chunkId) + "." + {"@walletconnect/universal-provider":"ef8efce1","@walletconnect/web3-provider~tronweb~web3~web3-utils":"0b428b54","@walletconnect/web3-provider~web3~web3-utils":"6480e4de","web3-utils":"9b75af01","tronweb~web3":"e1c64b96","web3":"1f3eb9a9","tronweb":"2f2c6180","add-role-modal":"8c90ef2f","cash-modals~job-modals":"90c88bc3","cash-modals":"6430b79e","ckeditor~public-page-vacancies~salary-pages":"aa9397df","ckeditor":"01561f37","salary-pages":"ad65f23e","date-picker":"760504ed","erc20-lht-v1":"9ab7308e","erc20-v1.json":"87746744","image-cropper":"a0c57859","lx-analytics":"354bd677","lx-contract-v1":"dc6e735e","lx-contract-v2":"47534421","private-pages~public-page-customers":"9f353eac","public-page-customers":"f49f0b8f","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"97b2c89f","public-page-jobs~public-page-vacancies":"9d0b43d3","jobs-modals~public-page-vacancies":"3755f9aa","public-page-vacancies":"f5859b1f","private-pages~public-page-jobs":"0a0a10f1","private-pages":"cd28f5d9","public-page-freelancers~public-page-gigs":"7743b8f1","public-page-freelancers":"45a9ad39","public-page-gigs":"8d206555","public-page-jobs":"bc7ad009","public-page-about":"c4bc5b4e","public-page-blog":"16a170ed","public-page-landing":"b68c6884","public-page-landing-copy":"79ab364a","public-page-mining":"8b261283","public-page-premium":"f65f993f","public-page-skills":"8fe2bdf1","qr-code":"16e452a4","recaptcha":"26134675","sentry":"42dad18d","settings-modals":"2b277b7e","swiper":"9c7befeb","time-warp-pool":"18067f89","vue-slider-component":"29a7d604","welcome-modal":"4b1bf2d8","@walletconnect/web3-provider":"9cd02317","skills-modals":"dbd9e1f2","job-modals":"4948e137","jobs-modals":"c76377cf","transak-sdk":"d939e716","gig-modals":"844b40fd","share-modal":"4ae70381","application-modal":"ea00c8d4","stack-grid":"4c847999"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"add-role-modal":1,"cash-modals~job-modals":1,"cash-modals":1,"ckeditor":1,"salary-pages":1,"date-picker":1,"image-cropper":1,"private-pages~public-page-customers":1,"public-page-customers":1,"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":1,"public-page-jobs~public-page-vacancies":1,"jobs-modals~public-page-vacancies":1,"public-page-vacancies":1,"private-pages~public-page-jobs":1,"private-pages":1,"public-page-freelancers~public-page-gigs":1,"public-page-freelancers":1,"public-page-gigs":1,"public-page-jobs":1,"public-page-about":1,"public-page-blog":1,"public-page-landing":1,"public-page-landing-copy":1,"public-page-mining":1,"public-page-premium":1,"public-page-skills":1,"settings-modals":1,"welcome-modal":1,"skills-modals":1,"job-modals":1,"jobs-modals":1,"gig-modals":1,"share-modal":1,"application-modal":1,"stack-grid":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"@walletconnect/universal-provider":"@walletconnect/universal-provider","@walletconnect/web3-provider~tronweb~web3~web3-utils":"@walletconnect/web3-provider~tronweb~web3~web3-utils","@walletconnect/web3-provider~web3~web3-utils":"@walletconnect/web3-provider~web3~web3-utils","web3-utils":"web3-utils","tronweb~web3":"tronweb~web3","web3":"web3","tronweb":"tronweb","add-role-modal":"add-role-modal","cash-modals~job-modals":"cash-modals~job-modals","cash-modals":"cash-modals","ckeditor~public-page-vacancies~salary-pages":"ckeditor~public-page-vacancies~salary-pages","ckeditor":"ckeditor","salary-pages":"salary-pages","date-picker":"date-picker","erc20-lht-v1":"erc20-lht-v1","erc20-v1.json":"erc20-v1.json","image-cropper":"image-cropper","lx-analytics":"lx-analytics","lx-contract-v1":"lx-contract-v1","lx-contract-v2":"lx-contract-v2","private-pages~public-page-customers":"private-pages~public-page-customers","public-page-customers":"public-page-customers","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies","public-page-jobs~public-page-vacancies":"public-page-jobs~public-page-vacancies","jobs-modals~public-page-vacancies":"jobs-modals~public-page-vacancies","public-page-vacancies":"public-page-vacancies","private-pages~public-page-jobs":"private-pages~public-page-jobs","private-pages":"private-pages","public-page-freelancers~public-page-gigs":"public-page-freelancers~public-page-gigs","public-page-freelancers":"public-page-freelancers","public-page-gigs":"public-page-gigs","public-page-jobs":"public-page-jobs","public-page-about":"public-page-about","public-page-blog":"public-page-blog","public-page-landing":"public-page-landing","public-page-landing-copy":"public-page-landing-copy","public-page-mining":"public-page-mining","public-page-premium":"public-page-premium","public-page-skills":"public-page-skills","qr-code":"qr-code","recaptcha":"recaptcha","sentry":"sentry","settings-modals":"settings-modals","swiper":"swiper","time-warp-pool":"time-warp-pool","vue-slider-component":"vue-slider-component","welcome-modal":"welcome-modal","@walletconnect/web3-provider":"@walletconnect/web3-provider","skills-modals":"skills-modals","job-modals":"job-modals","jobs-modals":"jobs-modals","transak-sdk":"transak-sdk","gig-modals":"gig-modals","share-modal":"share-modal","application-modal":"application-modal","stack-grid":"stack-grid"}[chunkId]||chunkId) + "." + {"@walletconnect/universal-provider":"31d6cfe0","@walletconnect/web3-provider~tronweb~web3~web3-utils":"31d6cfe0","@walletconnect/web3-provider~web3~web3-utils":"31d6cfe0","web3-utils":"31d6cfe0","tronweb~web3":"31d6cfe0","web3":"31d6cfe0","tronweb":"31d6cfe0","add-role-modal":"ea7004bd","cash-modals~job-modals":"480272e1","cash-modals":"53989041","ckeditor~public-page-vacancies~salary-pages":"31d6cfe0","ckeditor":"5466a9e6","salary-pages":"32883e6e","date-picker":"783cec79","erc20-lht-v1":"31d6cfe0","erc20-v1.json":"31d6cfe0","image-cropper":"523ffe84","lx-analytics":"31d6cfe0","lx-contract-v1":"31d6cfe0","lx-contract-v2":"31d6cfe0","private-pages~public-page-customers":"76c745e8","public-page-customers":"a39b3363","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"71f89e5d","public-page-jobs~public-page-vacancies":"eafc4924","jobs-modals~public-page-vacancies":"8d6aae89","public-page-vacancies":"64d0a116","private-pages~public-page-jobs":"e85097cb","private-pages":"9e6ab2fe","public-page-freelancers~public-page-gigs":"86950697","public-page-freelancers":"b654d2ed","public-page-gigs":"4c880854","public-page-jobs":"85e8fc9b","public-page-about":"d26f4371","public-page-blog":"e38c65d5","public-page-landing":"d5964161","public-page-landing-copy":"e4a3810e","public-page-mining":"c3aba7cd","public-page-premium":"d4b0577b","public-page-skills":"e2cd4701","qr-code":"31d6cfe0","recaptcha":"31d6cfe0","sentry":"31d6cfe0","settings-modals":"4fb26f92","swiper":"31d6cfe0","time-warp-pool":"31d6cfe0","vue-slider-component":"31d6cfe0","welcome-modal":"f72749b3","@walletconnect/web3-provider":"31d6cfe0","skills-modals":"39e109a0","job-modals":"488ac84d","jobs-modals":"b8cf41ec","transak-sdk":"31d6cfe0","gig-modals":"acfe38e7","share-modal":"faf29262","application-modal":"483e2994","stack-grid":"664b77f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
